module.exports = __webpack_public_path__ + "img/CV.Drainage.Manhole.Precast_concrete_manhole,_SfA_Type_1_between_3_to_6m_deep.ae80368d.png";